// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const MediaService = {
    InUse(fn, req) {
        try {
            fm.validateUrlParam(req["mediaItemId"], "mediaItemId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/media/v1/in-use/media-file/${req["mediaItemId"]}?${fm.renderURLSearchParams(req, ["mediaItemId"])}`, { method: "GET" });
    },
    FetchActiveHoldMusic(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/media/v1/locations/${req["locationId"]}/hold-music?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
};
